import moment from "moment-timezone";

function getCurrentSeason() {
    const currentMonth = moment().month();
    const currentYear = moment().year();
    let season;

    if (currentMonth >= 8 && currentMonth <= 10) { // September to November
        season = 'Fall';
    } else if (currentMonth >= 5 && currentMonth <= 7) { // June to August
        season = 'Summer';
    } else { // December to May
        season = 'Spring';
    }

    return `${season} ${currentYear}`;
}

export default getCurrentSeason